import getGeo from '../glb/geo';
import prevHotlead from './data.prevhotlead';
const isSSR = typeof window === 'undefined';

export default function () {
    return {
        isSSR,
        env: 'dev',
        geo: getGeo(),
        welcomeImage: '',
        phoneNumber: '6504450449',
        phoneNumber2: '',
        version: '',
        appUrl: '',
        cdnUrl: '',
        digsUrl: '',
        lightspeedUrl: '',
        staticUrl: '',
        boundaryUrl: '',
        requestUrlRaw: '',
        splitClientKey: undefined,
        googleMapKey: undefined,
        firebaseMessaging: undefined,
        googleLoginClientId: undefined,
        isDevelopment: false,
        isUserBrowser: undefined,
        pageType: '',
        muted: true,
        pageInfo: {
            value: '',
            sitesection: '',
            type: '',
            listing_pagetype: '',
            userType: '',
        },
        landingPage: '',
        landingPagePath: '',
        landingPageType: '',
        isPhone: undefined,
        isMobile: undefined,
        language: undefined,
        OS: undefined,
        extendedOS: undefined,
        randomId: '',
        menu: undefined,
        rentals: false,
        rentalLink: '',
        enableThirdPart: true,
        user: {
            id: '',
            fullName: '',
            email: '',
            phone: '',
            role: '',
            activated: false,
            ojoId: '',
            userType: '',
        },
        agent: {
            id: '',
            name: '',
            firstName: '',
            lastName: '',
            type: '',
            email: '',
            phone: '',
            isAgentFeedback: '',
            relationshipCreatedAt: '',
            profilePhotoUrl: '',
            biography: '',
            licenses: [],
        },
        assignedAgents: [],
        dppAssignedAgents: [],
        propertyStatus: {
            active: 'ACTIVE',
            pending: 'PENDING',
            sold: 'SOLD',
            removed: 'REMOVED',
            offMarket: 'OFF_MARKET',
            forRent: 'FOR_RENT',
        },
        propertyTypes: {
            single: 'SINGLE_FAMILY_HOUSE',
            multi: 'MULTI_FAMILY',
            land: 'LAND',
            mobile: 'MOBILE',
            condo: 'CONDO',
            other: 'OTHER',
            commercial: 'COMMERCIAL',
        },
        hotleadInfo: {},
        viewport: {
            xsScreen: [0, 639],
            smScreen: [640, 991],
            mdScreen: [992, 1399],
            lgScreen: [1400, 1750],
        },
        viewedListings: [],
        updatedViewedItem: null,
        progressStatus: 0,
        favoriteListings: [],
        subscriptions: [],
        digsSubscribe: [],
        feed: [],
        savedSearches: null,
        claimedHomes: null,
        claimedPropertiesList: null,
        updatedFavItem: null,
        initialed: false,
        loginToDoList: [],
        lastSearch: null,
        prevSearch: null,
        prevPath: '',
        recentSearchList: [],
        autoSuggest: null,
        autoSearchResult: [],
        mlsIds: [],
        seo: {
            title: '',
            h1: '',
            description: '',
        },
        metaObj: {
            canonicalUrl: '',
        },
        mortgagelink: '',
        refinancelink: '',
        veteranslink: '',
        cablelink: '',
        creditlink: '',
        insurancelink: '',
        recentlyViewed: [],
        recentlyViewedTags: [],
        zipNewListings: [],
        zipReducedListings: [],
        zipRecentlySoldListings: [],
        zipOpenListings: [],
        zipBestValueListings: [],
        cityNewListings: [],
        cityCondosListings: [],
        cityUrlListings: [],
        cityReducedListings: [],
        cityOpenListings: [],
        cityBestValueListings: [],
        surroundingListings: [],
        attributeNearbyHomes: {},
        brokerageAgents: [],
        nearbySold: [],
        nearbySale: [],
        listingCountObj: {},
        rentLang: '',
        neighborhoodNewListings: [],
        neighborhoodOpenListings: [],
        neighborhoodBestValueListings: [],
        neighborhoodReducedListings: [],
        tags: {},
        marketTrendsForInsights: {},
        splits: {},
        unit: 'metric',
        signalJWT: '',
        movotoDeviceID: '',
        mapType: 'roadmap',
        mapDetails: '',
        utm_campaign: '',
        utm_source: '',
        utm_medium: '',
        webpush: '',
        gclid: '',
        msclkid: '',
        selectedPoi: [],
        opendoor: null,
        nearbyHomes: [],
        nearbyVideos: null,
        nearbyPlaces: null,
        rentalNearbyAffordUrl: '',
        hideMlsInfo: false,
        prevHotlead: prevHotlead(),
        log: false,
        popLeadBeforeRedirect: false,
        authFormState: '',
        authErrorMessage: '',
        authRedirectUrl: '',
        filterLabel: [],
        compliance: {},
        removeAds: false,
        articleConfig: {
            tag: {},
            category: {},
        },
        disableLinkIndexing: false,
        disableDialogClose: false,
        query: null,
        vetting: {
            answers: {},
            hotlead: {
                hotLeadId: '',
                phone: '',
                houseRealStatus: '',
                propertyType: '',
                price: 0,
                zipcode: '',
                state: '',
                city: '',
                address: '',
                email: '',
                username: '',
                userType: '',
                trigger: '',
                mlsId: '',
                hotleadCount: 0,
                typeId: '',
                type: '',
            },
            outcome: {
                partnerData: null,
                agentData: null,
                mortgageData: null,
                initialStep: null,
                completeSessionReason: null,
                completeSessionStep: null,
                matchingInProgress: null,
                hasReferralOutcome: null,
            },
            history: [],
            stepPath: '',
        },
    };
}
